import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProposalRepositoryService {

  private Ecp_api = environment.apiUrl;
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  public getProposalData(domainType, searchText, from, size) {
    let requestBody = {
      domainType: domainType,
      queryString: searchText,
      from: from,
      size: size
    }
    const url = this.apiUrl + "Proposal/proposals";
    return this.http.post<any>(url, requestBody, this.httpOptions);
  }
  public getProposalfilterData(filteredData, searchText, from, size) {
    let requestBody = {
      filteredData: filteredData,
      queryString: searchText,
      from: from,
      size: size
    }
    
    const url = this.apiUrl + "Proposal/filterproposals";
    return this.http.post<any>(url, requestBody, this.httpOptions);
  }
  public delPropsalData(id) {
    const url = this.apiUrl + "Proposal/delete?proposalId=" + id;
    return this.http.delete<any>(url, this.httpOptions);
  }
  public downloadProposal(id) {

    const url = this.apiUrl + "Proposal/downloadattachment?proposalId=" + id;
    return this.http.get<any>(url, this.httpOptions);
  }
  public downloadOnlyProposal(id) {

    const url = this.apiUrl + "Proposal/downloadonlyattachment?proposalId=" + id;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getMostDownloadedProposals() {
    const url = `${this.apiUrl}Proposal/GetMostDownloadedProposals`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public updateViewCountByProposalId(id: number) {
    const url = `${this.apiUrl}Proposal/updateViewCountByProposalId?proposalId=${id}`;
    return this.http.post<any>(url, null, this.httpOptions);
  }

  public getMostViewedProposals() {
    const url = `${this.apiUrl}Proposal/GetMostViewedProposals`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public addRefDoc(filesData) {
    const url = `${this.apiUrl}ReferenceDocument/create`;
    return this.http.post<any>(url, filesData, this.httpOptions);
  }
  public getRefDoc(searchText, from, size) {
    const url = `${this.apiUrl}ReferenceDocument/GetAllReferenceDocuments?queryString=${searchText}&from=${from}&size=${size}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public delRefDoc(uuid, sharepointId) {
    const url = this.apiUrl + `ReferenceDocument/delete?id=${uuid}&sharepointId=${sharepointId}`;
    return this.http.delete<any>(url, this.httpOptions);
  }
  public downloadRefDoc(uuid, sharepointId) {

    const url = `${this.apiUrl}ReferenceDocument/download?id=${uuid}&sharepointId=${sharepointId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getProposalDataByGroup(field) {
    const url = `${this.apiUrl}Proposal/GroupedProposals?field=${field}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public editReferenceDocument(fileData) {

    const url = `${this.apiUrl}ReferenceDocument/Edit?name=${fileData.name}&description=${fileData.templateDescription}&id=${fileData.id}`;
    return this.http.put<any>(url, this.httpOptions);
  }
  public SearchByDomains(searchTemplateModel) {
    ;
    const url = `${this.apiUrl}Proposal/SearchProposals`;
    return this.http.post<any>(url, searchTemplateModel, this.httpOptions);
  }
  getAllDomains() {
    const url = `${this.apiUrl}SME/GetDomains`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getAllProposals(field) {
    const url = `${this.apiUrl}Proposal/GetAllProposalsWithoutSize?queryString=${field}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getAllDomainsWithProposalCount() {
    const url = `${this.apiUrl}Proposal/GetAllDomainsWithProposalCount`;
    return this.http.get<any>(url, this.httpOptions)
  }
  public getFileDownloadLink(imageId : string) : Observable<any> {
      return this.http.get<any>(`${this.Ecp_api}ECPUser/GetProgramImage?fileId=${imageId}`)
    }
}